import { Create, Datagrid, DeleteButton, EditButton, List, ReferenceField, ReferenceInput, required, SaveButton, SelectInput, TextField, Toolbar, useCreate, useNotify, useRecordContext, useRedirect } from 'react-admin';
import { Edit, SimpleForm, TextInput } from 'react-admin';

var bcrypt = require('bcryptjs');

// const ButtonEditPassword = ({ source }) => {
//     const record = useRecordContext();
//     console.log("record", record);
//     console.log("record source", record[source]);
//     return (<Link to="/sbml/import" style={{textDecoration: "none", display: getAuthData()["role"]=="2"?"none":"inline-flex"}}><Button variant="outlined" label='Import Template'/></Link>);
// };

export const AutentifikasiList = () => (
    <List>
        <Datagrid>
            <TextField source="id" />
            <TextField source="username" />
            {/* <TextField source="password" /> */}
            {/* <NumberField source="role" /> */}
            <ReferenceField source="role" label="Role" reference="role" link={false} >
                <TextField source="nama" />
            </ReferenceField>
            {/* <TextField source="kode_wilayah" /> */}
            <ReferenceField source="kode_wilayah" label="Wilayah" reference="master_kab" link={false} >
                <TextField source="nama_kab" />
            </ReferenceField>
            <EditButton/>

        </Datagrid>
    </List>
);

// import { DateInput, Edit, NumberInput, SimpleForm, TextInput } from 'react-admin';

export const AutentifikasiEdit = () => {
    const transform = data => ({
        ...data,
        password : bcrypt.hashSync(data.password, 8)
    });
    return <Edit transform={transform}>
        <SimpleForm>
            {/* <TextInput source="id" /> */}
            <TextInput source="username" validate={[required()]} />
            <TextInput source="password" type={"password"} />
            {/* <NumberInput source="role" /> */}
            <ReferenceInput source="role" reference="role">
                <SelectInput optionText="nama" validate={[required()]}/>
            </ReferenceInput>
            {/* <DateInput source="kode_wilayah" /> */}
            <ReferenceInput source="kode_wilayah" reference="master_kab">
                <SelectInput optionText="nama_kab" validate={[required()]}/>
            </ReferenceInput>
            
        </SimpleForm>
    </Edit>
};

const AutentifikasiSaveButton = props => {
    const notify = useNotify();
    const redirect = useRedirect();
    return <SaveButton {...props} type="button" 
        mutationOptions={{
            onSuccess: (response) => {
                notify(`User "${response.username}" created!`);
                redirect('/autentifikasi');
        }}
    } 
    />;
};

export const AutentifikasiCreate = () => {
    const transform = data => ({
        ...data,
        password : bcrypt.hashSync(data.password, 8)
    });

    return <Create transform={transform} redirect="/autentifikasi">
        {/* <SimpleForm toolbar={<AutentifikasiCreateToolbar />} onSubmit={postSave} > */}
        <SimpleForm >
            {/* <TextInput source="id" /> */}
            <TextInput source="username" validate={[required()]} />
            <TextInput source="password" validate={[required()]} />
            {/* <NumberInput source="role" /> */}
            <ReferenceInput source="role" reference="role">
                <SelectInput optionText="nama" validate={[required()]}/>
            </ReferenceInput>
            {/* <DateInput source="kode_wilayah" /> */}
            <ReferenceInput source="kode_wilayah" reference="master_kab">
                <SelectInput optionText="nama_kab" validate={[required()]}/>
            </ReferenceInput>
            
        </SimpleForm>
    </Create>
};